// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { getMany } from '../../../../../common/utils/immutableHelper';
import { hasChanged } from '../../../../utils/react/propsComparisons';
import {
    getNotificationId,
    getNotificationObservedTimestamp,
} from '../../../../../common/notifications/notificationModelUtils';

// Selectors
import { currentBoardObservedNotificationIdsSelector } from '../../../../element/activity/selectors/boardActivitySelector';
import { getNotificationsSelector } from '../../../../notifications/notificationsSelector';

// Actions
import { markNotificationsAsObserved } from '../../../../notifications/notificationActions';

const observedNotificationIdsHasChanged = hasChanged('notificationIdsToMarkAsObserved');

const EMPTY_LIST = [];

const getNotificationIdsToMarkAsObserved = createShallowSelector(
    currentBoardObservedNotificationIdsSelector,
    getNotificationsSelector,
    (currentBoardObservedNotificationIds, notifications) => {
        if (!currentBoardObservedNotificationIds || !currentBoardObservedNotificationIds.length) {
            return EMPTY_LIST;
        }

        const currentlyObservedNotifications = getMany(currentBoardObservedNotificationIds, notifications);

        // Only mark notifications that have not already been marked
        return currentlyObservedNotifications
            .filter((notification) => !getNotificationObservedTimestamp(notification))
            .map(getNotificationId)
            .toArray();
    },
);

const mapStateToProps = createStructuredSelector({
    notificationIdsToMarkAsObserved: getNotificationIdsToMarkAsObserved,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchMarkNotificationsAsObserved: (notificationIds) => dispatch(markNotificationsAsObserved(notificationIds)),
});

export default (DecoratedComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class NotificationsObservedDecorator extends React.Component {
        componentWillReceiveProps(nextProps) {
            const { notificationIdsToMarkAsObserved, dispatchMarkNotificationsAsObserved } = nextProps;

            if (
                notificationIdsToMarkAsObserved &&
                notificationIdsToMarkAsObserved.length &&
                observedNotificationIdsHasChanged(this.props, nextProps)
            ) {
                dispatchMarkNotificationsAsObserved(notificationIdsToMarkAsObserved);
            }
        }

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    NotificationsObservedDecorator.propTypes = {
        notificationIdsToMarkAsObserved: PropTypes.array,
        dispatchMarkNotificationsAsObserved: PropTypes.func,
    };

    return NotificationsObservedDecorator;
};
